import loading from '../helpers/loading'
import collectionPerPage from '../helpers/collectionPerPage'

import actions from './actions'

export default {
  namespaced: true,
  state: {
    ...loading.state,
    ...collectionPerPage.state,
    userError: null
  },
  mutations: {
    ...loading.mutations,
    ...collectionPerPage.mutations,
    userError: (state, { error }) => (state.userError = error)
  },
  getters: {
    ...loading.getters,
    ...collectionPerPage.getters
  },
  actions
}



// WEBPACK FOOTER //
// ./src/store/skiliko/users/index.js